"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCannabisPackageCreateInputSchema = exports.APosCannabisPackageSchema = exports.APosCannabisPackageStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosCannabisPackageStatusSchema = zod_1.z.enum([
    'active', 'in_transit', 'sold', 'disposed', 'quarantined', 'returned',
]);
exports.APosCannabisPackageSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    packageId: id_schema_1.EntityIdSchema,
    metrcTag: zod_1.z.string().min(1).max(50),
    variantId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    batchId: id_schema_1.EntityIdSchema.optional(),
    quantity: zod_1.z.number().nonnegative(),
    unitOfMeasure: zod_1.z.enum(['grams', 'ounces', 'units', 'milligrams']),
    packageDate: zod_1.z.number(),
    harvestDate: zod_1.z.number().optional(),
    labTestId: id_schema_1.EntityIdSchema.optional(),
    labTestPassed: zod_1.z.boolean().optional(),
    thcContent: zod_1.z.number().min(0).max(100).optional(),
    cbdContent: zod_1.z.number().min(0).max(100).optional(),
    totalTerpenes: zod_1.z.number().min(0).max(100).optional(),
    status: exports.APosCannabisPackageStatusSchema.default('active'),
    notes: zod_1.z.string().max(2000).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosCannabisPackageCreateInputSchema = zod_1.z.object({
    metrcTag: zod_1.z.string().min(1).max(50),
    variantId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    batchId: id_schema_1.EntityIdSchema.optional(),
    quantity: zod_1.z.number().nonnegative(),
    unitOfMeasure: zod_1.z.enum(['grams', 'ounces', 'units', 'milligrams']),
    packageDate: zod_1.z.number(),
    harvestDate: zod_1.z.number().optional(),
    thcContent: zod_1.z.number().min(0).max(100).optional(),
    cbdContent: zod_1.z.number().min(0).max(100).optional(),
    totalTerpenes: zod_1.z.number().min(0).max(100).optional(),
    notes: zod_1.z.string().max(2000).optional(),
});
//# sourceMappingURL=cannabis-package.schema.js.map